import React, { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { setActiveCareersSliders } from "store/slices";
import CareerDesktop from "./Desktop";

const Career = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      dispatch(setActiveCareersSliders(null));
    };
  }, []);

  return (
    <>
      <CareerDesktop />
    </>
  );
};

export default Career;
